// extracted by mini-css-extract-plugin
export default {"styleIconWrapper":"Settings_styleIconWrapper__U171F"};